import { apiHelpers } from '../utils/api';
import type {
  RefillVisitResponse,
  RefillVisitsResponse,
  CreateRefillVisitData,
  UpdateRefillVisitData,
  GetRefillVisitsQuery,
  MachinesNeedingRefillResponse,
  GetMachinesNeedingRefillQuery
} from '../types/rental';

export const refillService = {
  // ========== Refill Visits ==========

  // Get all refill visits with filters
  getRefillVisits: async (query?: GetRefillVisitsQuery): Promise<RefillVisitsResponse> => {
    const params = new URLSearchParams();

    if (query?.page) params.append('page', query.page.toString());
    if (query?.limit) params.append('limit', query.limit.toString());
    if (query?.contractId) params.append('contractId', query.contractId);
    if (query?.startDate) params.append('startDate', query.startDate);
    if (query?.endDate) params.append('endDate', query.endDate);
    if (query?.employeeId) params.append('employeeId', query.employeeId);

    return await apiHelpers.get(`/refills?${params.toString()}`);
  },

  // Get single refill visit by ID
  getRefillVisit: async (id: string): Promise<RefillVisitResponse> => {
    return await apiHelpers.get(`/refills/${id}`);
  },

  // Create new refill visit
  createRefillVisit: async (data: CreateRefillVisitData): Promise<RefillVisitResponse> => {
    return await apiHelpers.post('/refills', data);
  },

  // Update refill visit
  updateRefillVisit: async (id: string, data: UpdateRefillVisitData): Promise<RefillVisitResponse> => {
    return await apiHelpers.put(`/refills/${id}`, data);
  },

  // Get machines needing refill
  getMachinesNeedingRefill: async (query?: GetMachinesNeedingRefillQuery): Promise<MachinesNeedingRefillResponse> => {
    const params = new URLSearchParams();

    if (query?.daysAhead) params.append('daysAhead', query.daysAhead.toString());
    if (query?.customerId) params.append('customerId', query.customerId);
    if (query?.status) params.append('status', query.status);

    return await apiHelpers.get(`/refills/due?${params.toString()}`);
  },

  // ========== Refill Schedules ==========

  // Get due/upcoming refills
  getDueRefills: async (daysAhead?: number): Promise<any> => {
    const params = new URLSearchParams();
    if (daysAhead) params.append('daysAhead', daysAhead.toString());

    return await apiHelpers.get(`/refills/due?${params.toString()}`);
  },

  // Create new refill schedule
  createRefillSchedule: async (data: {
    contractId: string;
    machineId: string;
    scheduleType: 'AUTO' | 'ON_DEMAND';
    nextRefillDate: string;
    intervalDays: number;
  }): Promise<any> => {
    return await apiHelpers.post('/refills/schedules', data);
  },

  // Update refill schedule
  updateRefillSchedule: async (id: string, data: {
    scheduleType?: 'AUTO' | 'ON_DEMAND';
    nextRefillDate?: string;
    intervalDays?: number;
    isActive?: boolean;
  }): Promise<any> => {
    return await apiHelpers.patch(`/refills/schedules/${id}`, data);
  }
};
